import qs from 'qs';

type routesParamsT = {
  [key: string]: string;
};

export const replaceRouteParams = (path: string, routesParams: routesParamsT): string => {
  if (!path.length) {
    return '';
  }

  if (!Object.keys(routesParams).length) {
    return path;
  }

  let pathString = path;

  Object.keys(routesParams).forEach(paramKey => {
    pathString = pathString.replace(`:${paramKey}`, routesParams[paramKey]);
  });

  return pathString;
};

export const urlQueryStringify = (queryObject: object) => {
  return qs.stringify(queryObject, { encode: false });
};
